/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/receipt-text
 */
import { default as DefaultIcon } from '~icons/lucide/receipt-text';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ReceiptTextIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
